// extracted by mini-css-extract-plugin
export default {"DesyncedCalculator":"DesyncedCalculator_DesyncedCalculator__nVs5O"};